import { Skeleton } from 'antd';

const Loading: React.FC = () => (
  <Skeleton style={{ padding: '24px 40px', height: '60vh' }} active />
);

export default Loading;
